<template>
    <div v-if="loading_cart === true">
      <loading />
    </div>
    <div v-else>
      <div class="col s12 m12 no-padding doc-type-section">
        <div class="input-field col s12 m6">
          <select v-model="conselho.pf_cart_class_tipo">
            <option v-bind:value="null" selected>Selecione</option>
            <option v-for="(conselho, i) in conselhos" v-bind:key="i" v-bind:value="conselho.sigla">{{ conselho.nome }}</option>
          </select>
          <label for="og_emissor">Conselho de Classe</label>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="conselho.pf_cart_class" id="num_conselho" type="text" class="validate">
          <label for="num_conselho">Número de cadastro</label>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="conselho.pf_cart_class_emissao" v-mask="['##/##/####']" id="data_expedicao_conselho" type="text" class="validate">
          <label for="data_expedicao_conselho">Data de expedição</label>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="conselho.pf_cart_class_validade" v-mask="['##/##/####']" id="data_validade_conselho" type="text" class="validate">
          <label for="data_validade_conselho">Data de validade</label>
        </div>
        <div class="input-field col s12 m12">
          <button @click="prepareSubmitConselho" v-bind:disabled="verificaForm === false" class="btn right" type="button">SALVAR</button>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import {converteData, formataData} from '@/assets/js/form-utils.js'
import {CONFIG} from '@/config/config.js'
import SocialService from '@/services/social-service.js'
import { verificaData } from '@/assets/js/form-utils'
import sha1 from 'js-sha1'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'ConselhoClasse',
  components: {
    'loading': Loading,
  },
  props: {
      doc: Object,
      pf_id: String
  },
  data (){
    return {
      loading_cart: false,
      meta: this.$store.state.meta.data,
      conselho: {
        pf_cart_class_tipo: this.doc.cart_class_tipo,
        pf_cart_class: this.doc.cart_class,
        pf_cart_class_emissao: (verificaData(this.doc.cart_class_emissao, 'YYYY-MM-DD') === true ? converteData(this.doc.cart_class_emissao) : null),
        pf_cart_class_validade: (verificaData(this.doc.cart_class_validade, 'YYYY-MM-DD') === true ? converteData(this.doc.cart_class_validade) : null),
      },
      error_fields: {},
      loaded: null,
      conselhos: [
        {sigla: 'CFA', nome: 'Conselho Federal de Administração'},
        {sigla: 'CRA', nome: 'Conselho Regional de Administração'},
        {sigla: 'OAB', nome: 'Ordem dos Advogados do Brasil Nacional'},
        {sigla: 'OAB', nome: 'Ordem dos Advogados do Brasil Seccional'},
        {sigla: 'CAU', nome: 'Conselho de Arquitetura e Urbanismo do Brasil'},
        {sigla: 'CFESS', nome: 'Conselho Federal de Serviço Social'},
        {sigla: 'CRESS', nome: 'Conselho Regional de Serviço Social'},
        {sigla: 'CFB', nome: 'Conselho Federal de Biblioteconomia'},
        {sigla: 'CRB', nome: 'Conselho Regional de Biblioteconomia'},
        {sigla: 'CFBIO', nome: 'Conselho Federal de Biologia'},
        {sigla: 'CRBIO', nome: 'Conselho Regional de Biologia'},
        {sigla: 'CFBM', nome: 'Conselho Federal de Biomedicina'},
        {sigla: 'CRBM', nome: 'Conselho Regional de Biomedicina'},
        {sigla: 'CFC', nome: 'Conselho Federal de Contabilidade'},
        {sigla: 'CRC', nome: 'Conselho Regional de Contabilidade'},
        {sigla: 'COFECI', nome: 'Conselho Federal de Corretores de Imóveis'},
        {sigla: 'CRECI', nome: 'Conselho Regional de Corretores de Imóveis'},
        {sigla: 'COFECON', nome: 'Conselho Federal de Economia'},
        {sigla: 'CORECON', nome: 'Conselho Regional de Economia'},
        {sigla: 'CONFEF', nome: 'Conselho Federal de Educação Física'},
        {sigla: 'CREF', nome: 'Conselho Regional de Educação Física'},
        {sigla: 'COFEN', nome: 'Conselho Federal de Enfermagem'},
        {sigla: 'COREN', nome: 'Conselho Regional de Enfermagem'},
        {sigla: 'CONFEA', nome: 'Conselho Federal de Engenharia e Agronomia'},
        {sigla: 'CREA', nome: 'Conselho Regional de Engenharia e Agronomia'},
        {sigla: 'CONFE', nome: 'Conselho Federal de Estatística'},
        {sigla: 'CONRE', nome: 'Conselho Regional de Estatística'},
        {sigla: 'CFF', nome: 'Conselho Federal de Farmácia'},
        {sigla: 'CRF', nome: 'Conselho Regional de Farmácia'},
        {sigla: 'COFFITO', nome: 'Conselho Federal de Fisioterapia e Terapia Ocupacional'},
        {sigla: 'CREFITO', nome: 'Conselho Regional de Fisioterapia e Terapia Ocupacional'},
        {sigla: 'CFFa', nome: 'Conselho Federal de Fonoaudiologia'},
        {sigla: 'CREFONO', nome: 'Conselho Regional de Fonoaudiologia'},
        {sigla: 'CFM', nome: 'Conselho Federal de Medicina'},
        {sigla: 'CRM', nome: 'Conselho Regional de Medicina'},
        {sigla: 'CFMV', nome: 'Conselho Federal de Medicina Veterinária'},
        {sigla: 'CRMV', nome: 'Conselho Regional de Medicina Veterinária'},
        {sigla: 'COFEM', nome: 'Conselho Federal de Museologia'},
        {sigla: 'COREM', nome: 'Conselho Regional de Museologia'},
        {sigla: 'OMB', nome: 'Ordem dos Músicos do Brasil'},
        {sigla: 'CFN', nome: 'Conselho Federal de Nutrição'},
        {sigla: 'CRN', nome: 'Conselho Regional de Nutrição'},
        {sigla: 'CFO', nome: 'Conselho Federal de Odontologia'},
        {sigla: 'CRO', nome: 'Conselho Regional de Odontologia'},
        {sigla: 'CFP', nome: 'Conselho Federal de Psicologia do Brasil'},
        {sigla: 'CRP', nome: 'Conselho Regional de Psicologia do Brasil'},
        {sigla: 'CFQ', nome: 'Conselho Federal de Química'},
        {sigla: 'CRQ', nome: 'Conselho Regional de Química'},
        {sigla: 'CONFERP', nome: 'Conselho Federal de Relações-públicas'},
        {sigla: 'CONFERE', nome: 'Conselho Federal dos Representantes Comerciais'},
        {sigla: 'CORE', nome: 'Conselho Regional dos Representantes Comerciais'},
        {sigla: 'CONTER', nome: 'Conselho Nacional de Técnicos em Radiologia'},
        {sigla: 'CRTR', nome: 'Conselho Regional de Técnicos em Radiologia'},
        {sigla: 'CFT', nome: 'Conselho Federal dos Técnicos Industriais'},
        {sigla: 'CRT', nome: 'Conselho Regional dos Técnicos Industriais'}
      ],
    }
  },
  computed: {
    verificaForm: function() {
      let status = (
          Object.keys(this.conselho).filter((k) => this.conselho[k] && this.conselho[k] != '').length === 3
          && 
          (verificaData(this.conselho.pf_cart_class_emissao) === true)
      )
      this.$emit('statusChange', {
        doc: 6,
        status: status
      })
      return status
    }
  },
  methods: {
    async submitInsertCart(cart){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/cart-class/`, {
        ...cart,
        ...{
          'pf_id': this.pf_id,
          'device': await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.loading_cart = false
        setTimeout(() => {
          this.initFields()
          this.$emit('docSaved', 5)
        }, 100)
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_cart = false
        setTimeout(() => {
          this.initFields()
        }, 100)
      })
    },
    prepareSubmitConselho(){
      this.loading_cart = true
      let a = this.conselho //Atual

      let conselho = {
        pf_id: this.pf_id,
        pf_cart_class_tipo: this.conselho.pf_cart_class_tipo,
        pf_cart_class: this.conselho.pf_cart_class,
        pf_cart_class_emissao: (verificaData(this.conselho.pf_cart_class_emissao, 'YYYY-MM-DD') === true ? formataData(this.conselho.pf_cart_class_emissao) : null),
        pf_cart_class_validade: (verificaData(this.conselho.pf_cart_class_validade, 'YYYY-MM-DD') === true ? formataData(this.conselho.pf_cart_class_validade) : null)
      }
      if(this.loaded !== sha1(JSON.stringify(conselho))){
        return this.submitInsertCart(conselho)
      } else {
        this.loading_cart = false
        this.$emit('docSaved', 5)
      }
    },
    initFields () {
      M.updateTextFields()
      M.FormSelect.init(document.querySelectorAll('select'))
    },
    verificaStatusDocumento(){
      return true //Não obrigatório
    }
  },
  mounted(){
    this.loaded = sha1(JSON.stringify({
      pf_id: this.pf_id,
      pf_cart_class_tipo: this.conselho.pf_cart_class_tipo,
      pf_cart_class: this.conselho.pf_cart_class,
      pf_cart_class_emissao: (verificaData(this.conselho.pf_cart_class_emissao, 'YYYY-MM-DD') === true ? formataData(this.conselho.pf_cart_class_emissao) : null),
      pf_cart_class_validade: (verificaData(this.conselho.pf_cart_class_validade, 'YYYY-MM-DD') === true ? formataData(this.conselho.pf_cart_class_validade) : null)
    }))

    this.initFields()
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/steps/documentos/ConselhoClasse.vue